var Globalis = window.Globalis || {}

Globalis.Map = function () {
  var map, config
  var storageFolderPath = '/var/storage/'

  function fn (domId, mapConfig) {
    config = mapConfig || {}

    L.Icon.Default.imagePath = 'http://cdn.leafletjs.com/leaflet-0.6.4/images' // TODO

    var crs = L.CRS.EPSG3857

    if (config.type === 'choropleth' || config.type === 'categorical') {
      //crs.scale = function(zoom) { return 190 * Math.pow(2, zoom); };

      // World Mollweide: http://spatialreference.org/ref/esri/54009/
      crs = new L.Proj.CRS('ESRI:54009', '+proj=moll +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs', {
          resolutions: [100000, 50000, 25000, 12500, 6250, 3125, 1562.5, 781.25]
        }
      )

    }

    var options = {
      crs: crs,
      minZoom: 1,
      maxZoom: 6
    }

    if (config.static) {
      L.extend(options, {
        zoomControl: false,
        dragging: false,
        touchZoom: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        keyboard: false
      })
    }

    map = L.map(domId, options)

    map.attributionControl.setPrefix()

    switch(config.type) {
      case 'choropleth':
      case 'categorical':
        L.graticule({
          sphere: true,
          style: {
            color: '#777',
            weight: 1,
            opacity: 1,
            fillColor: config.fillColor || '#E0EEF8',
            fillOpacity: 1
          }
        }).addTo(map)
  
        L.graticule({
          style: {
            color: '#000',
            opacity: 0.1,
            weight: 1
          }
        }).addTo(map)
        
        break
      case 'choroplethAlternative':
        var southWest = L.latLng(-90, -180)
        var northEast = L.latLng(90, 180)
        // L.setMaxBounds(L.latLngBounds(southWest, northEast)).addTo(map)
        map.setMaxBounds(L.latLngBounds(southWest, northEast))
        break
      default:
        map.on({
          layeradd: layerAdd,
          layerremove: layerRemove
        })
        break

    }
    
    if (config.layers) {
      for (var i = 0; i < config.layers.length; ++i) {
        Globalis.Map.createTileLayer(config.layers[i], map).addTo(map)
      }
    }

    if (config.bounds) {
      var bounds = config.bounds
      map.fitBounds([[bounds[1], bounds[0]], [bounds[3], bounds[2]]])	// left, bottom, right, top
    } else {
      if (config.type === 'choropleth' || config.type === 'categorical') {
        map.setView([0, 0], 0)
      } else if (config.type === 'embed' && config.zoomfix === 'oneup') {
        map.setView([0, 0], 2)
      } else if (config.marker) {
        map.setView(config.marker, config.zoom || 3)
      } else {
        map.fitBounds([[-40, -120], [60, 140]])
      }
    }

    switch (config.type) {
      case 'choroplethAlternative':
        choroplethMap()
        break
      case 'choropleth':
        choroplethMap()
        break
      case 'categorical':
        categoricalMap()
        break
      case 'cluster':
        clusterMap()
        break
      case 'selected':
        selectedMap()
        break
      case 'embed':
        embeddedMap()
        break
    }

    if (config.country) {
      addCountryBorder()
    }

    if (config.marker) {
      L.marker(config.marker).addTo(map)
    }

    if (config.click) {
      map.on({
        click: function (evt) {
          window.location.href = config.click
        }
      })
    }

    map.scrollWheelZoom.disable()
  }

  // TODO: Avoid listening to each GeoJSON feature
  function layerAdd (evt) {
    if (evt.layer.options && evt.layer.options.legend && evt.layer.options.legend.length !== 0) {
      addLegend(evt.layer)
    }
  }

  function layerRemove (evt) {
    if (evt.layer.legendControl) {
      evt.layer.legendControl.removeFrom(map)
    }
  }

  function addCountryBorder () {
    var resolutions = ['110m', '110m', '50m', '50m', '50m', '10m', '10m', '10m'],
      borders = {}

    function fetchCountryBorder (zoom, callback) {
      var resolution = resolutions[zoom]
      if (!borders[resolution]) {
        // $.ez( 'map::fetchCountryBorder', {object_id: config.country, resolution: resolution}, function( data ) {
        //     borders[resolution] = JSON.parse(data.content);
        //     callback(borders[resolution]);
        // });
        $.get('/api/getMapData/fetchCountryBorder?object_id=' + config.country + '&resolution=' + resolution, function (data) {
          borders[resolution] = JSON.parse(data.content)
          callback(borders[resolution])
        })

      } else {
        callback(borders[resolution])
      }
    }

    L.geoJsonZoom(fetchCountryBorder, {
      style: {
        fill: false,
        color: '#000',
        opacity: 0.8,
        weight: 2
      }
    }).addTo(map)
  }

  function choroplethMap () {

    function createMap (geojson) {
      var choropleth = L.choropleth(geojson, config).addTo(map)

      if (!config.removeLegend && choropleth.options && choropleth.options.legend && choropleth.options.legend.length !== 0) {
        addLegend(choropleth)
      }
    }

    if (Globalis.geojson_countries_110m) {
      createMap(Globalis.geojson_countries_110m)

    } else if (typeof config.geojson === 'string') {
      $.getJSON(config.geojson, function (geojson) {
        Globalis.geojson_countries_110m = geojson
        createMap(geojson)
      })
    }

  }

  function categoricalMap () {
    var features = {}

    function getGeoJson (zoom, callback) {
      var resolution = '110m'
      if (!features[resolution]) {
        $.getJSON(config.featuresUrl, function (data) {
          features[resolution] = data
          callback(data)
        })
      } else {
        callback(features[resolution])
      }
    }

    // $.ez( config.dataUrl, config.dataParams, function( data ) {
    //     var options = JSON.parse(data.content);
    //
    //     options._onClick = function(evt) {
    //         var props = evt.target.feature.properties;
    //         if (props && props.path){
    //             window.top.location.href = config.baseUrl + '/' + props.path;
    //         }
    //     };
    //
    //     var categorical = L.categorical(getGeoJson, options).addTo(map);
    //
    //     if (categorical.options && categorical.options.legend && categorical.options.legend.length !== 0){
    //         addLegend(categorical);
    //     }
    //
    // });

    $.get(config.dataUrl, config.dataParams, function (data) {
      var options = data

      options._onClick = function (evt) {
        var props = evt.target.feature.properties
        if (props && props.path) {
          window.top.location.href = config.baseUrl + props.path
        }
      }

      var categorical = L.categorical(getGeoJson, options).addTo(map)

      if (categorical.options && categorical.options.legend && categorical.options.legend.length !== 0) {
        addLegend(categorical)
      }
    }, 'json')
  }

  function clusterMap () {
    // $.ez( config.dataUrl, config.dataParams, function( data ) {
    //     var items = JSON.parse(data.content);
    //
    //     var cluster = new L.MarkerClusterGroup({
    //         showCoverageOnHover: false,
    //         maxClusterRadius: 55
    //     });
    //
    //     cluster.on('click', function (e) {
    //         window.location.href = config.baseUrl + '/' + e.layer.options.url;
    //     });
    //
    //     cluster.addLayers(arrayToMarkers(items));
    //     map.addLayer(cluster);
    // });
  }

  function selectedMap () {
    var layerControl = L.control.layersDropdown({}, {}, {})

    // $.ez( 'map::fetchSelectedLayers', {}, function( data ) {
    //     var layers 	 = JSON.parse(data.content),
    //         basemaps = layers.basemaps,
    //         overlays = layers.overlays;
    //
    //     for (var i = 0; i < basemaps.length; ++i) {
    //         var basemap = basemaps[i];
    //         var layer = Globalis.Map.createTileLayer(basemap, map);
    //         if (basemap.id === config.activeLayer) layer.addTo(map);
    //         layerControl.addBaseLayer(layer, basemap.name);
    //     }
    //
    //     for (var i = 0; i < overlays.length; ++i) {
    //         var overlay = overlays[i];
    //         var layer = Globalis.Map.createTileLayer(overlay, map);
    //         //if (overlay.visible) layer.addTo(map);
    //         layer.addTo(map);
    //         layerControl.addOverlay(layer, overlay.name);
    //     }
    //
    //     layerControl.addTo(map);
    // });

    $.get('/api/getMapData/fetchSelectedLayers', function (data) {
      var layers = JSON.parse(data.content),
        basemaps = layers.basemaps,
        overlays = layers.overlays

      for (var i = 0; i < basemaps.length; ++i) {
        var basemap = basemaps[i]
        var layer = Globalis.Map.createTileLayer(basemap, map)
        if (basemap.id == config.activeLayer) layer.addTo(map)
        layerControl.addBaseLayer(layer, basemap.name)
      }

      for (var i = 0; i < overlays.length; ++i) {
        var overlay = overlays[i]
        var layer = Globalis.Map.createTileLayer(overlay, map)
        //if (overlay.visible) layer.addTo(map);
        layer.addTo(map)
        layerControl.addOverlay(layer, overlay.name)
      }

      layerControl.addTo(map)
    })
  }

  function embeddedMap () {
    var layerControl = L.control.layers({}, {}, {})

    // $.ez( 'map::fetchEmbedLayer', {object_id: config.layer}, function( data ) {
    //     var layers 	 = JSON.parse(data.content),
    //         basemap  = layers.basemap,
    //         overlays = layers.overlays;
    //
    //     basemap.legend = null; // Not enough room
    //
    //     var layer = Globalis.Map.createTileLayer(basemap, map);
    //     layer.addTo(map);
    //     layerControl.addBaseLayer(layer, basemap.name);
    //
    //     for (var i = 0; i < overlays.length; ++i) {
    //         var overlay = overlays[i];
    //         layer = Globalis.Map.createTileLayer(overlay, map);
    //         if (overlay.visible) layer.addTo(map);
    //         layerControl.addOverlay(layer, overlay.name);
    //     }
    //
    //     layerControl.addTo(map);
    // });

    $.get('/api/getMapData/fetchEmbedLayer', {object_id: config.layer}, function (data) {
      var layers = JSON.parse(data.content),
        basemap = layers.basemap,
        overlays = layers.overlays

      basemap.legend = null // Not enough room

      var layer = Globalis.Map.createTileLayer(basemap, map)
      layer.addTo(map)
      layerControl.addBaseLayer(layer, basemap.name)

      for (var i = 0; i < overlays.length; ++i) {
        var overlay = overlays[i]
        layer = Globalis.Map.createTileLayer(overlay, map)
        if (overlay.visible) layer.addTo(map)
        layerControl.addOverlay(layer, overlay.name)
      }

      layerControl.addTo(map)
    })
  }

  function addLegend (layer) {
    if (layer.legendControl) {
      layer.legendControl.addTo(map)
    }
    else if (layer.options.legend) {

      var options = layer.options
      layer.legendControl = L.control({position: layer.options.legendPosition || 'bottomright'})

      if (options.tinyLegend) {

        layer.legendControl.onAdd = function (map) {
          var div = L.DomUtil.create('div', 'leaflet-control-legend leaflet-control-legend-tiny leaflet-control-legend-' + layer.options.id)
          var html = ''
          if (options.unit || options.name) {
            html += '<h4>' + ((options.unit) ? options.unit : options.name) + '</h4>'
            html += '<span class="leaflet-control-legend-first">' + options.classBreaks[0] + '</span>'
          }
          for (var i = 0; i < options.legend.length; i++) {
            var item = options.legend[i]
            if (item.color || item.style.charAt(0) === '#') {
              html += '<i class="globalis-legend-color" style="background:' + (item.color || item.style) + '" title="' + item.name + '"></i>'
            } else {
              html += '<i class="globalis-legend-' + item.style + '" title="' + item.name + '"></i>'
            }
          }
          html += '<span class="leaflet-control-legend-last">' + options.classBreaks[options.classBreaks.length - 1] + '</span>'
          div.innerHTML = html
          return div
        }

      } else {

        layer.legendControl.onAdd = function (map) {
          var div = L.DomUtil.create('div', 'leaflet-control-legend leaflet-control-legend-' + layer.options.id)
          var html = ''
          if (options.unit || options.name) {
            html += '<h4>' + ((options.unit) ? options.unit : options.name) + '</h4>'
          }
          for (var i = 0; i < options.legend.length; i++) {
            var item = options.legend[i]
            if (item.color || item.style.charAt(0) === '#') {
              html += '<i class="globalis-legend-color" style="background:' + (item.color || item.style) + '"></i><span>' + item.name + '</span><div class="clear"></div>'
            } else {
              html += '<i class="globalis-legend-' + item.style + '"></i><span>' + item.name + '</span><div class="clear"></div>'
            }
          }
          if (!options.panel && options.introduction) {
            html += '<p>' + options.introduction + '</p>'
          }
          div.innerHTML = html
          return div
        }

      }

      layer.legendControl.addTo(map)

    }
  }

  function arrayToMarkers (arr) {
    var l = []
    for (var i = 0; i < arr.length; ++i) {
      var item = arr[i]
      l.push(new L.Marker([item.lat, item.lng], {
        title: item.name,
        url: item.url
      }))
    }
    return l
  }

  return {
    init: function (domId, config) {
      fn(domId, config)
      return this
    },
    getMap: function () {
      return map
    },
    remove: function () {
      if (map)
        map.remove()
    }
  }

}

Globalis.Map.createTileLayer = function (config, map) {
  if (config.service === '0') { // S3/TMS
    config.tms = true
  }

  if (config.service === '2') { // MapBox
    return Globalis.Map.createInteractiveLayer(config, map)
  } else {
    return L.tileLayer('//globalis.s3.amazonaws.com/maptiles/3785/{id}/{z}/{x}/{y}.png', config)
  }
}

Globalis.Map.createInteractiveLayer = function (config, map) {
  var layerGroup = L.layerGroup()

  config.sid = config.sid || config.id

  layerGroup.addLayer(L.tileLayer('//{s}.tiles.mapbox.com/v3/globalis.{sid}/{z}/{x}/{y}.png', config))

  L.Util.ajax('//api.tiles.mapbox.com/v3/globalis.' + config.sid + '.json', function (tilejson) {
    if (tilejson.grids) {
      var utfGrid = new L.UtfGrid('//{s}.tiles.mapbox.com/v3/globalis.world-religions/{z}/{x}/{y}.grid.json?callback={cb}')

      layerGroup.addLayer(utfGrid)

      var template = '{HighRelig}: {ReligCatP}'

      var label = new L.Label({
        direction: 'auto'
      })

      utfGrid.on('mouseover', function (e) {
        label.setLatLng(e.latlng).setContent(Globalis.Map.translation(config.translation, config.template, e.data))
        map.addLayer(label)
      })

      utfGrid.on('mouseout', function (e) {
        map.removeLayer(label)
      })

      utfGrid.on('mousemove', function (e) {
        label.setLatLng(e.latlng)
      })

      map.on('baselayerchange', function (e) {
        map.removeLayer(label)
      })
    }
  })

  return layerGroup
}

Globalis.Map.translation = function (lang, str, data) {
  return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
    return lang[data[key]] || data [key]
  })
}